import Role from '../../enums/role';
import CalculationStatus from '../../enums/calculationStatus';
import CalculationAction from '../../enums/calculationAction';
import ActionsBuilder from '../../helpers/actionsBuilder';
import StatementStatus from '../../enums/statementStatus';
import { isRectification } from '../../helpers/calculation/table';
const submittedStatement = (statementStatus) => statementStatus === StatementStatus.Submitted;
const canReopenCalculation = ({ statementStatus, calculationNameId, companyHasActiveRectification }) => !(submittedStatement(statementStatus) || (isRectification(calculationNameId) && companyHasActiveRectification));
const viewCalculationAction = ActionsBuilder.addActions(CalculationAction.View).build();
const calculationActionsMap = {
    [Role.Creator]: {
        [CalculationStatus.New]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.DraftCreator]: ({ calculationBaseDetails: { companyActiveRoles }, userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(userIsAssigned && companyActiveRoles.includes(Role.Verifier), CalculationAction.SendToVerifier)
            .addConditionalActions(userIsAssigned && !companyActiveRoles.includes(Role.Verifier), CalculationAction.SendToApprover)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.ToBeSubmitted]: ({ calculationBaseDetails }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(canReopenCalculation(calculationBaseDetails), CalculationAction.ReopenNonUniversalRole)
            .addConditionalActions(!submittedStatement(calculationBaseDetails.statementStatus), CalculationAction.ConfirmSubmission)
            .build(),
        [CalculationStatus.ToBeReopened]: ({ calculationBaseDetails: { reopeningInvolvedRoles } }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(!reopeningInvolvedRoles.includes(Role.Creator), CalculationAction.ApproveReopening, CalculationAction.RejectReopening)
            .build(),
        [CalculationStatus.ToBeVerified]: () => ActionsBuilder
            .addActions(CalculationAction.View)
            .addActions(CalculationAction.Recall)
            .build(),
        [CalculationStatus.ToBeApproved]: () => ActionsBuilder
            .addActions(CalculationAction.View)
            .addActions(CalculationAction.Recall)
            .build(),
        [CalculationStatus.RejectedCreator]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.RejectedCreatorAndVerifier]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.Reopened]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build()
    },
    [Role.Verifier]: {
        [CalculationStatus.ToBeVerified]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addActions(CalculationAction.Reject)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.DraftVerifier]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit, CalculationAction.Reject, CalculationAction.SendToApprover)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.ToBeSubmitted]: ({ calculationBaseDetails }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(canReopenCalculation(calculationBaseDetails), CalculationAction.ReopenNonUniversalRole)
            .addConditionalActions(!submittedStatement(calculationBaseDetails.statementStatus), CalculationAction.ConfirmSubmission)
            .build(),
        [CalculationStatus.ToBeReopened]: ({ calculationBaseDetails: { reopeningInvolvedRoles } }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(!reopeningInvolvedRoles.includes(Role.Verifier), CalculationAction.ApproveReopening, CalculationAction.RejectReopening)
            .build(),
        [CalculationStatus.ToBeApproved]: () => ActionsBuilder
            .addActions(CalculationAction.View)
            .addActions(CalculationAction.Recall)
            .build(),
        [CalculationStatus.RejectedCreatorAndVerifier]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.Reopened]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build()
    },
    [Role.Approver]: {
        [CalculationStatus.ToBeApproved]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addActions(CalculationAction.Reject)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.DraftApprover]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit, CalculationAction.Approve, CalculationAction.Reject)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.ToBeSubmitted]: ({ calculationBaseDetails }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(canReopenCalculation(calculationBaseDetails), CalculationAction.ReopenNonUniversalRole)
            .addConditionalActions(!submittedStatement(calculationBaseDetails.statementStatus), CalculationAction.ConfirmSubmission)
            .build(),
        [CalculationStatus.ApprovedDraft]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit, CalculationAction.CloseForSubmissionNonUniversalRole)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.Approved]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit, CalculationAction.CloseForSubmissionNonUniversalRole)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.ToBeReopened]: ({ calculationBaseDetails: { reopeningInvolvedRoles } }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(!reopeningInvolvedRoles.includes(Role.Approver), CalculationAction.ApproveReopening, CalculationAction.RejectReopening)
            .build(),
        [CalculationStatus.Reopened]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build()
    },
    [Role.Universal]: {
        [CalculationStatus.New]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.DraftUniversal]: ({ userIsAssigned }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(userIsAssigned, CalculationAction.Edit, CalculationAction.CloseForSubmissionUniversalRole)
            .addConditionalActions(!userIsAssigned, CalculationAction.Assign)
            .build(),
        [CalculationStatus.ToBeSubmitted]: ({ calculationBaseDetails }) => ActionsBuilder
            .addActions(CalculationAction.View)
            .addConditionalActions(canReopenCalculation(calculationBaseDetails), CalculationAction.ReopenUniversalRole)
            .addConditionalActions(!submittedStatement(calculationBaseDetails.statementStatus), CalculationAction.ConfirmSubmission)
            .build()
    }
};
export const getCalculationActions = (params) => {
    var _a;
    const { userRole, calculationBaseDetails: { status } } = params;
    if (!userRole)
        return viewCalculationAction;
    return (((_a = calculationActionsMap[userRole]) === null || _a === void 0 ? void 0 : _a[status]) || (() => viewCalculationAction))(params);
};
